"use client"

import React from 'react';
import CountUp from 'react-countup';

interface AnimatedCounterProps {
    end: number;
    suffix?: string;
    duration?: number;
    delay?: number;
}

export default function AnimatedCounter({
                                            end,
                                            suffix = "",
                                            duration = 2,
                                            delay = 0
                                        }: AnimatedCounterProps) {
    return (
        <CountUp end={end} suffix={suffix} duration={duration} delay={delay} />
    );
}